/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { colors } from '@blend/consumer-components';
import paperStack from './paper-stack.svg';
import { DocumentStatus } from '@shared/constants/document';

export namespace NoPdfPlaceHolder {
  export interface Props {
    status?: DocumentStatus;
  }
}

const styles = StyleSheet.create({
  wrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  docFromPreviousCall: {
    textAlign: 'center',
    color: colors.darkerGray,
    fontSize: 14,
    lineHeight: '20px',
  },
});

export const NoPdfPlaceHolder: React.FC<NoPdfPlaceHolder.Props> = ({ status }) => {
  if (!status) {
    return null;
  }
  const actionText =
    status === DocumentStatus.COMPLETED ? 'completed' : status === DocumentStatus.VOIDED ? 'voided' : null;
  return (
    <div className={css(styles.wrapper)} data-it="NoPdfPlaceHolder">
      <div className={css(styles.docFromPreviousCall)}>
        <div>
          <img src={paperStack} alt={'Paper stack'} />
        </div>
        {actionText && (
          <div>
            This document was {actionText} earlier
            <br /> and cannot be viewed at this time.
          </div>
        )}
      </div>
    </div>
  );
};
